// extracted by mini-css-extract-plugin
export default {"main":"error_main__ur1jp","logo":"error_logo__l+FO-","h1":"error_h1__-uWan","p":"error_p__QSJe4"};